/**
 * Configurações de URLs dos serviços FotUp
 * Centraliza todas as URLs para facilitar manutenção e deploy
 */

export interface ServiceUrls {
  frontend: string;
  backend: string;
  uploader: string;
  storage: string;
  pyimg: string;
}

/**
 * Obtém as URLs dos serviços baseadas no ambiente
 */
export function getServiceUrls(): ServiceUrls {
  const isDevelopment = import.meta.env.MODE === 'development';
  
  if (isDevelopment) {
    return {
      frontend: import.meta.env.URL_BASE_FRONTEND || 'http://localhost:3000',
      backend: import.meta.env.URL_BASE_BACKEND || 'http://localhost:3001',
      uploader: import.meta.env.URL_BASE_BACKEND || 'http://localhost:3001',
      storage: import.meta.env.URL_BASE_BACKEND || 'http://localhost:3001',
      pyimg: import.meta.env.URL_BASE_BACKEND || 'http://localhost:3001'
    };
  }
  
  // URLs de produção (serão configuradas via variáveis de ambiente)
  return {
    frontend: import.meta.env.VITE_FRONTEND_URL || 'https://fotup.com',
    backend: import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br',
    uploader: import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br',
    storage: import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br',
    pyimg: import.meta.env.URL_BASE_BACKEND || 'https://fotup-api.devonno.com.br'
  };
}

/**
 * Obtém a URL do uploader com AuthCode
 */
export function getUploaderUrlWithAuthCode(authCode: string): string {
  const urls = getServiceUrls();
  return `${urls.uploader}/auth?code=${authCode}`;
}

/**
 * Obtém a URL base do backend para APIs
 */
export function getBackendApiUrl(): string {
  const urls = getServiceUrls();
  return urls.backend;
}

/**
 * Obtém a URL do uploader
 */
export function getUploaderUrl(): string {
  const urls = getServiceUrls();
  return urls.uploader;
}

// Exportar URLs para uso direto
export const SERVICE_URLS = getServiceUrls();
